import type { Route } from '@ant-design/pro-layout/lib/typings';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import useConsoleMenu from '../../../layouts/ConsoleLayout/useConsoleMenu';
import NotFoundPage from '../../portal/NotFoundPage';

const getFirstRoute = (route: Route) => {
    const routes = route.routes?.filter(item => !item.isSubMenu);
    if (routes?.length > 0) {
        return getFirstRoute(routes[0]);
    }

    return route.path;
};

const DashboardRedirection = () => {
    const menu = useConsoleMenu();

    const firstRoute = getFirstRoute(menu);

    const navigate = useNavigate();

    useEffect(() => {
        if (firstRoute) {
            navigate(firstRoute, { replace: true });
        }
    }, [firstRoute, navigate]);

    return firstRoute ? null : <NotFoundPage />;
};

export default DashboardRedirection;
